/**
 * @generated SignedSource<<d08307186700df21550dc7859ac7638e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CloseFormControl_closeForm_Mutation$variables = {
  formId: string;
};
export type CloseFormControl_closeForm_Mutation$data = {
  readonly closeForm: {
    readonly form: {
      readonly id: string;
      readonly isClosed: boolean;
    };
  } | null;
};
export type CloseFormControl_closeForm_Mutation = {
  response: CloseFormControl_closeForm_Mutation$data;
  variables: CloseFormControl_closeForm_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "formId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "formId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "FormsCloseFormMutationPayload",
    "kind": "LinkedField",
    "name": "closeForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Form",
        "kind": "LinkedField",
        "name": "form",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClosed",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CloseFormControl_closeForm_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CloseFormControl_closeForm_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e224527009ee3e6f2ab6874637a1ddf9",
    "id": null,
    "metadata": {},
    "name": "CloseFormControl_closeForm_Mutation",
    "operationKind": "mutation",
    "text": "mutation CloseFormControl_closeForm_Mutation(\n  $formId: ID!\n) {\n  closeForm(input: {id: $formId}) {\n    form {\n      id\n      isClosed\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc39df483fc275774e6cb2cc2436d351";

export default node;
